import { useMemo } from 'react'

import {
  DEFAULT_LETTERHEAD_LOGO_SIZE_PX,
  getLetterheadBackgroundHex,
  getLetterheadTextColor,
} from 'src/utils/letterhead'

import { CenterType, LetterheadFormValues } from './types'

type Props = {
  formValues: LetterheadFormValues
}

const LetterheadPreview = ({ formValues }: Props) => {
  const backgroundHex = useMemo(
    () => getLetterheadBackgroundHex(formValues.backgroundColor),
    [formValues.backgroundColor]
  )
  const textColor = useMemo(
    () => getLetterheadTextColor(formValues.backgroundColor),
    [formValues.backgroundColor]
  )

  const logoMaxSize = formValues.centerFileWidthPx ?? DEFAULT_LETTERHEAD_LOGO_SIZE_PX

  return (
    <div
      className="flex w-full max-w-3xl items-center justify-between rounded px-8 py-2.5 text-sm shadow"
      style={{ backgroundColor: backgroundHex, color: textColor }}
    >
      <div className="flex-1 text-left whitespace-pre-wrap">{formValues.leftText}</div>
      <div className="flex flex-1 items-center justify-center">
        {formValues.centerType === CenterType.FILE && formValues.centerFile ? (
          <img
            src={formValues.centerFile?.url?.signedUrl}
            alt="Center logo"
            className="object-contain"
            style={{ maxWidth: logoMaxSize, maxHeight: logoMaxSize }}
          />
        ) : (
          <span className="text-xl whitespace-pre-wrap">{formValues.centerText}</span>
        )}
      </div>
      <div className="flex-1 text-right whitespace-pre-wrap">{formValues.rightText}</div>
    </div>
  )
}

export default LetterheadPreview
